import { apiClient, apiClientPaginated } from '@/lib/api-client';

/**
 * Ops simulation Sadha T19 — card / UPI a till took offline on a manual slip.
 * It is 'paid offline — unverified' until a manager checks the slip or the bank
 * statement and marks it verified (audited). Nothing clears it automatically.
 */
export interface OfflinePayment {
  bill_id: string;
  /** The bill's server number (INV…). */
  bill_number: string;
  /** The till's number printed on the customer's receipt (OFL…). */
  offline_bill_number: string;
  location_id: string | null;
  location_name: string | null;
  /** CARD / UPI / SPLIT as the till recorded it. */
  payment_method: string;
  /** Card + UPI part to check, in the tenant's minor unit. */
  unverified_amount: number;
  grand_total: number;
  /** Slip / approval / UPI reference the cashier typed, if any. */
  payment_reference: string | null;
  payment_verification: 'UNVERIFIED' | 'VERIFIED';
  cashier_name: string | null;
  verified_by_name: string | null;
  verified_at: string | null;
  verification_note: string | null;
  sold_at: string;
}

export type OfflinePaymentStatus = 'UNVERIFIED' | 'VERIFIED' | 'ALL';

export const offlinePaymentService = {
  list(params: { status?: OfflinePaymentStatus; page?: number; limit?: number } = {}) {
    const query = new URLSearchParams();
    if (params.status) query.set('status', params.status);
    if (params.page) query.set('page', String(params.page));
    if (params.limit) query.set('limit', String(params.limit));
    const qs = query.toString();
    return apiClientPaginated<OfflinePayment[]>(`/bills/offline-payments${qs ? `?${qs}` : ''}`);
  },

  verify(billId: string, note?: string) {
    return apiClient<{ id: string; payment_verification: 'VERIFIED'; verified_by: string; verified_at: string }>(
      `/bills/${encodeURIComponent(billId)}/offline-payment/verify`,
      { method: 'POST', body: note?.trim() ? { note: note.trim() } : {} },
    );
  },
};
